import { Component, OnInit } from '@angular/core';
import {PaypalTransactionDetailsAction} from './paypal-transaction-details.action';
import {PermissionConstants} from '../../../shared/constants/permission-constants';
import {AppConstants} from '../../../shared/constants/app-constants';
import {DataManagerService} from '../../../data/services/DataManager/data-manager.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-paypal-transaction-details',
    templateUrl: './paypal-transaction-details.component.html',
    styleUrls: ['./paypal-transaction-details.component.css'],
    standalone: false
})
export class PaypalTransactionDetailsComponent extends PaypalTransactionDetailsAction implements OnInit {
  _router: Router;
  canRefund: boolean;
  transactionDetails: object;
  recordId: string;
  fileURL: string;

  constructor(router: Router, private _route: ActivatedRoute, dataManager: DataManagerService) {
    super();

    this._router = router;
    this.router = router;
    this.route = _route;
    this.dataManager = dataManager;
    this.canRefund = this.permissionCheck(PermissionConstants.PERMISSION_CREATE_REFUND);

    this._route.queryParams.subscribe((params) => {
      if (params['id']) {
        this.setRecordId(params['id']);
        this._apiGetUrl = AppConstants.BASE_URL + '/paypal/transaction-details/' + this.recordId;
        this._getTransactionPdf = AppConstants.BASE_URL + '/paypal/download/' + this.recordId;
        this._apiRefundUrl = AppConstants.BASE_URL + '/orders/paypal/' + this.recordId + '/refund';
      }
    });
  }

  ngOnInit(): void {
    this.loadFlag = true;
    this.getPaymentDetails();
  }

  protected setRecordId(recordId: string): void {
    this.recordId = recordId;
  }

  protected passPaymentDetails(paymentDetails) {
    this.loadFlag = false;
    this.transactionDetails = paymentDetails.data;
  }

  protected passApiError(error) {
    this.loadFlag = false;
  }

  protected passTransactionPdfResponse(res: any) {
    this.openFileInBrowser(res);
  }

  protected passTransactionPdfError(err: any) {
    console.log(err);
  }

  protected passTransactionPdfComplete() {
    const link = document.createElement('a');
    link.href = this.fileURL;
    link.download = `paypal-transaction-details-${this.recordId}.pdf`;
    link.click();
  }

  openFileInBrowser(res) {
    this.fileURL = URL.createObjectURL(res);
  }

  viewPDF() {
    this.getTransactionPDF();
    this.showSnackBar('File is loading.', 'Ok', 3000);
  }

  doRefund() {
    const data  = {
        id: this.transactionDetails['id'],
        amount_captured: this.transactionDetails['amount'] * 100,
        amount: this.transactionDetails['amount'] * 100,
        isPaypalRefund: true,
      };
    localStorage.setItem(this.CUSTOMER_DATA, JSON.stringify(data));
    this.router.navigate(['../create-refund'], {queryParams: {id: data['id']}, relativeTo: this.route});
  }
}
